import {FunctionComponent} from 'react';
import {Page, useForm} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useUniversitySearchQueryConfig} from '../../../query/University/Query';
import UniversitiesContent, {UniversitySearchForm} from './UniversitiesContent';

const Universities: FunctionComponent = () => {

    const [form, onFormChange] = useForm<UniversitySearchForm>(f => ({
        searchQuery: f.input('')
    }));

    const [config, setPage] = useUniversitySearchQueryConfig(form.values);
    const query = useQuery(config);

    return (
        <Page className={'admin-universities-page'}>
            { query.data &&
                <UniversitiesContent
                    universities={query.data}
                    form={form}
                    onFormChange={onFormChange}
                    onPageChange={setPage} />
            }
        </Page>
    );
};

export default Universities;
